var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bg-white md__card--holder" },
    [
      _c("UserPickerModal", {
        attrs: {
          visible: _vm.modals.assignedBy,
          title: "Assigned By",
          role: "CREATOR",
          multi: false,
        },
        on: {
          okClicked: _vm._onAssignedByUsersChanged,
          closeClicked: function ($event) {
            _vm.modals.assignedBy = false
          },
        },
        model: {
          value: _vm.task.assignedBy,
          callback: function ($$v) {
            _vm.$set(_vm.task, "assignedBy", $$v)
          },
          expression: "task.assignedBy",
        },
      }),
      _c("UserPickerModal", {
        attrs: {
          visible: _vm.modals.assignedTo,
          title: "Assigned To",
          role: "ASSIGNEE",
          multi: false,
        },
        on: {
          okClicked: _vm._onAssignedToUsersChanged,
          closeClicked: function ($event) {
            _vm.modals.assignedTo = false
          },
        },
        model: {
          value: _vm.task.assignedTo,
          callback: function ($$v) {
            _vm.$set(_vm.task, "assignedTo", $$v)
          },
          expression: "task.assignedTo",
        },
      }),
      _c("UserPickerModal", {
        attrs: {
          visible: _vm.modals.cc,
          title: "CCed To",
          role: "CC",
          multi: true,
        },
        on: {
          okClicked: _vm._onCCUsersChanged,
          closeClicked: function ($event) {
            _vm.modals.cc = false
          },
        },
        model: {
          value: _vm.task.cc,
          callback: function ($$v) {
            _vm.$set(_vm.task, "cc", $$v)
          },
          expression: "task.cc",
        },
      }),
      _c("UserPickerModal", {
        attrs: {
          visible: _vm.modals.csu,
          title: "CSU To Client",
          role: "CLIENT",
          multi: true,
        },
        on: {
          okClicked: _vm._onCSUUsersChanged,
          closeClicked: function ($event) {
            _vm.modals.csu = false
          },
        },
        model: {
          value: _vm.task.csu,
          callback: function ($$v) {
            _vm.$set(_vm.task, "csu", $$v)
          },
          expression: "task.csu",
        },
      }),
      _c("div", { staticClass: "card d-flex flex-column shadow-none" }, [
        _c(
          "div",
          {
            staticClass:
              "chat-head card-header mb-auto d-flex flex-wrap align-items-center",
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "d-flex chat-header-container w-100 row mb-2 mx-md-12",
              },
              [
                _c("div", {
                  staticClass: "col-md-12 h3 mb-0 p-0 task-title",
                  attrs: { contenteditable: false },
                  domProps: {
                    innerHTML: _vm._s("Change Users for " + _vm.editTitle),
                  },
                  on: {
                    keypress: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      $event.preventDefault()
                      return _vm.onTitleChanged($event)
                    },
                    blur: function ($event) {
                      return _vm.onTitleChanged($event)
                    },
                    focus: _vm._onTitleFocusClicked,
                  },
                }),
              ]
            ),
          ]
        ),
        _c("div", { staticClass: "chat-message bottom-bar" }, [
          _c("div", { staticClass: "row mx-0" }, [
            _c("div", { staticClass: "col-xl-12 comment-box chat-box" }, [
              _c("div", { staticClass: "card-body chat-box__top bb-0" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex comment-header w-100 justify-content-between",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "comment-header__left d-flex align-self-center",
                      },
                      [
                        _c("div", { staticClass: "chat-admin mr-4 d-flex" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "avatar-group avatar-group--cc-sm d-flex align-items-center appendCced appendCced-int",
                            },
                            [
                              _vm.task.assignedBy
                                ? _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip.top-center",
                                          value:
                                            _vm.task.assignedBy.user
                                              .first_name +
                                            " " +
                                            _vm.task.assignedBy.user.last_name,
                                          expression:
                                            "\n                        task.assignedBy.user.first_name +\n                          ' ' +\n                          task.assignedBy.user.last_name\n                      ",
                                          modifiers: { "top-center": true },
                                        },
                                      ],
                                      staticClass:
                                        "to-2 avatar avatar--38 rounded-circle text-md",
                                      class: _vm.userAvatar(
                                        _vm.task.assignedBy &&
                                          _vm.task.assignedBy.user
                                      ).bg,
                                      attrs: {
                                        href: "javascript:void(0)",
                                        "data-placement": "top",
                                        "data-target": "offcanvascced_int",
                                        "data-offcanvasfrom": "offcanvas",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.modals.assignedBy = _vm.canEdit
                                        },
                                      },
                                    },
                                    [
                                      !_vm.userAvatar(
                                        _vm.task.assignedBy &&
                                          _vm.task.assignedBy.user
                                      ).hasImage
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.userAvatar(
                                                  _vm.task.assignedBy &&
                                                    _vm.task.assignedBy.user
                                                ).avatar
                                              )
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm.userAvatar(
                                        _vm.task.assignedBy &&
                                          _vm.task.assignedBy.user
                                      ).hasImage
                                        ? _c("img", {
                                            attrs: {
                                              alt: "Image placeholder",
                                              src: _vm.userAvatar(
                                                _vm.task.assignedBy &&
                                                  _vm.task.assignedBy.user
                                              ).avatar,
                                            },
                                          })
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _vm._m(0),
                          _c(
                            "div",
                            {
                              staticClass:
                                "avatar-group avatar-group--cc-sm d-flex align-items-center appendCced appendCced-int",
                            },
                            [
                              _vm.task.assignedTo
                                ? _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip.top-center",
                                          value:
                                            _vm.task.assignedTo.user
                                              .first_name +
                                            " " +
                                            _vm.task.assignedTo.user.last_name,
                                          expression:
                                            "\n                        task.assignedTo.user.first_name +\n                          ' ' +\n                          task.assignedTo.user.last_name\n                      ",
                                          modifiers: { "top-center": true },
                                        },
                                      ],
                                      staticClass:
                                        "to-2 avatar avatar--38 rounded-circle text-md",
                                      class: _vm.userAvatar(
                                        _vm.task.assignedTo &&
                                          _vm.task.assignedTo.user
                                      ).bg,
                                      attrs: {
                                        href: "javascript:void(0)",
                                        "data-target": "offcanvascced_int",
                                        "data-offcanvasfrom": "offcanvas",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.modals.assignedTo =
                                            _vm.task && _vm.canEdit
                                        },
                                      },
                                    },
                                    [
                                      !_vm.userAvatar(
                                        _vm.task.assignedTo &&
                                          _vm.task.assignedTo.user
                                      ).hasImage
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.userAvatar(
                                                  _vm.task.assignedTo &&
                                                    _vm.task.assignedTo.user
                                                ).avatar
                                              )
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm.userAvatar(
                                        _vm.task.assignedTo &&
                                          _vm.task.assignedTo.user
                                      ).hasImage
                                        ? _c("img", {
                                            attrs: {
                                              alt: "Image placeholder",
                                              src: _vm.userAvatar(
                                                _vm.task.assignedTo &&
                                                  _vm.task.assignedTo.user
                                              ).avatar,
                                            },
                                          })
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                              !_vm.task.assignedTo
                                ? _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip.top-center",
                                          value: `Add new user`,
                                          expression: "`Add new user`",
                                          modifiers: { "top-center": true },
                                        },
                                      ],
                                      staticClass:
                                        "to-3 avatar avatar--38 rounded-circle",
                                      attrs: {
                                        href: "javascript:void(0)",
                                        "data-target": "offcanvascced_int",
                                        "data-offcanvasfrom": "offcanvas",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.modals.assignedTo = _vm.canEdit
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fas fa-plus text-xs",
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center mr-4 mb-sm-0",
                          },
                          [
                            _c("div", { staticClass: "comment-header__cc" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "avatar-group avatar-group--cc-sm d-flex align-items-center appendCced appendCced-int",
                                },
                                [
                                  _vm._l(_vm.task.cc, function (u, i) {
                                    return _c(
                                      "a",
                                      {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip.top-center",
                                            value:
                                              u.user.first_name +
                                              " " +
                                              u.user.last_name,
                                            expression:
                                              "u.user.first_name + ' ' + u.user.last_name",
                                            modifiers: { "top-center": true },
                                          },
                                        ],
                                        key: i,
                                        staticClass:
                                          "to-2 avatar avatar--38 rounded-circle text-md",
                                        class: _vm.userAvatar(u && u.user).bg,
                                        attrs: { href: "javascript:void(0)" },
                                        on: {
                                          click: function ($event) {
                                            _vm.modals.cc =
                                              _vm.task && _vm.canEdit
                                          },
                                        },
                                      },
                                      [
                                        !_vm.userAvatar(u && u.user).hasImage
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.userAvatar(u && u.user)
                                                    .avatar
                                                )
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm.userAvatar(u && u.user).hasImage
                                          ? _c("img", {
                                              attrs: {
                                                alt: "Image placeholder",
                                                src: _vm.userAvatar(u && u.user)
                                                  .avatar,
                                              },
                                            })
                                          : _vm._e(),
                                      ]
                                    )
                                  }),
                                  _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip.top-center",
                                          value: `Add user`,
                                          expression: "`Add user`",
                                          modifiers: { "top-center": true },
                                        },
                                      ],
                                      staticClass:
                                        "to-3 avatar avatar--38 rounded-circle",
                                      attrs: {
                                        href: "javascript:void(0)",
                                        "data-target": "offcanvascced_int",
                                        "data-offcanvasfrom": "offcanvas",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.modals.cc =
                                            _vm.task && _vm.canEdit
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fas fa-plus text-xs",
                                      }),
                                    ]
                                  ),
                                ],
                                2
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "comment-header__switch custom-toggle",
                              },
                              [
                                _vm.canEdit
                                  ? _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.hasCsu,
                                          expression: "hasCsu",
                                        },
                                      ],
                                      staticClass:
                                        "custom-control-input switch-btn",
                                      attrs: {
                                        type: "checkbox",
                                        id: "grayscale",
                                        value: "grayscale",
                                        name: "grayscale_switch",
                                      },
                                      domProps: {
                                        checked: Array.isArray(_vm.hasCsu)
                                          ? _vm._i(_vm.hasCsu, "grayscale") > -1
                                          : _vm.hasCsu,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a = _vm.hasCsu,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = "grayscale",
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.hasCsu = $$a.concat([$$v]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.hasCsu = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.hasCsu = $$c
                                          }
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _c("span", {
                                  staticClass:
                                    "custom-toggle-slider rounded-circle",
                                  attrs: {
                                    id: "showRadio",
                                    "data-label-off": "OFF",
                                    "data-label-on": "ON",
                                  },
                                }),
                              ]
                            ),
                            _vm.hasCsu
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "comment-header__cc__ext pl-2 ml-1",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "avatar-group avatar-group--cc-sm d-flex align-items-center appendCced appendCced-ext",
                                      },
                                      [
                                        _vm._l(_vm.task.csu, function (u, i) {
                                          return _c(
                                            "a",
                                            {
                                              key: i,
                                              staticClass:
                                                "to-2 avatar avatar--38 rounded-circle text-md",
                                              class: _vm.userAvatar(u && u.user)
                                                .bg,
                                              attrs: {
                                                href: "javascript:void(0)",
                                                "data-toggle": "tooltip",
                                                title:
                                                  u.user.first_name +
                                                  " " +
                                                  u.user.last_name,
                                                "data-target":
                                                  "offcanvascced_int",
                                                "data-offcanvasfrom":
                                                  "offcanvas",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.modals.csu =
                                                    _vm.task && _vm.canEdit
                                                },
                                              },
                                            },
                                            [
                                              !_vm.userAvatar(u && u.user)
                                                .hasImage
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.userAvatar(
                                                          u && u.user
                                                        ).avatar
                                                      )
                                                    ),
                                                  ])
                                                : _vm._e(),
                                              _vm.userAvatar(u && u.user)
                                                .hasImage
                                                ? _c("img", {
                                                    attrs: {
                                                      alt: "Image placeholder",
                                                      src: _vm.userAvatar(
                                                        u && u.user
                                                      ).avatar,
                                                    },
                                                  })
                                                : _vm._e(),
                                            ]
                                          )
                                        }),
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "to-3 avatar avatar--38 rounded-circle",
                                            attrs: {
                                              href: "javascript:void(0)",
                                              "data-toggle": "tooltip",
                                              title: "Add User",
                                              "data-target":
                                                "offcanvascced_int",
                                              "data-offcanvasfrom": "offcanvas",
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.modals.csu =
                                                  _vm.task && _vm.canEdit
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fas fa-plus text-xs",
                                            }),
                                          ]
                                        ),
                                      ],
                                      2
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "d-inline-flex pr add-icn align-self-center ml-2 mr-2" },
      [_c("a", [_c("i", { staticClass: "fas fa-arrow-right text-xs" })])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }